import { useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../app/store';
import { useAuth } from '../signin/auth';
import DateInput from './DateInput';
import EntryInput from './EntryInput';
import { listMeasurements, selectAllMeasurements, selectEntryDate, setEntryDate } from './measurementsSlice';
import { Measurement } from './types';

function EditEntries() {
  const auth = useAuth();
  const dispatch = useDispatch<AppDispatch>();
  const entryDate = useSelector(selectEntryDate);
  const measurements = useSelector(selectAllMeasurements);
  const status = useSelector((state: RootState) => state.measurements.status);
  const error = useSelector((state: RootState) => state.measurements.error);

  useEffect(() => {
    if (status === 'idle' || status === 'failed') {
      if (auth.authToken) {
        dispatch(listMeasurements({ authToken: auth.authToken }));
      } else {
        console.log('No auth token!');
      }
    }
  }, [status, dispatch, auth.authToken])

  const onEntryDateInput = (newValue: number) => {
    dispatch(setEntryDate(newValue));
  }

  return (
    <div>
      {status === 'loading' && <div className="loader">Loading...</div>}
      {status === 'failed' && <div>{error}</div>}
      <Form>
        <DateInput value={entryDate} onChange={onEntryDateInput} />
        {measurements.map((m: Measurement) => m.active && (
          <EntryInput measurement={m} entryID={entryDate.toString()} key={m.id} />
        ))}
      </Form>
    </div>
  );
}

export default EditEntries;